import useLocalization from "@/hooks/useLocalization";
import Box from "@mui/material/Box";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";

type SentinelProps = {
  canFetchMoreReservations: boolean;
  totalReservations: number;
  reachedSentinelLabel: string;
  loading: boolean;
  showNoReservations?: boolean;
  progressProps?: LinearProgressProps;
};
export default function Sentinel({
  canFetchMoreReservations,
  totalReservations,
  reachedSentinelLabel,
  loading,
  showNoReservations = false,
  progressProps,
}: SentinelProps) {
  const { t } = useLocalization();
  const { sx: progressSx, ...otherProgressProps } = progressProps ?? {};
  const shouldShowNoReservations =
    showNoReservations && totalReservations === 0 && !loading;

  return (
    <Box position="relative">
      {!shouldShowNoReservations && loading ? (
        <LinearProgress
          sx={{
            position: "absolute",
            width: "100%",
            zIndex: 2,
            ...progressSx,
          }}
          {...otherProgressProps}
        />
      ) : (
        <Box sx={{ textAlign: "center" }}>
          <Typography>
            {shouldShowNoReservations
              ? t("reservation:noReservations")
              : canFetchMoreReservations
                ? ""
                : reachedSentinelLabel}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
